import { t } from "@/i18n-js/instance";
import { AccessForm } from "@circle-react/components/Spaces/CustomizeSpaceFullPage/AccessForm";
import {
  isCourseSpace,
  isDraftSpace,
} from "@circle-react/helpers/spaceHelpers";
import type { Space } from "@circle-react/types/Space";
import { SectionCard } from "@circle-react-uikit/SectionCard";
import { DraftAlert } from "./DraftAlert";

interface AccessSectionProps {
  onChange: (hasChanges: boolean) => void;
  onExit: () => void;
  space: Space;
}

export const AccessSection = ({
  space,
  onChange,
  onExit,
}: AccessSectionProps) => {
  const shouldShowDraftMessage = isCourseSpace(space) && isDraftSpace(space);

  return (
    <SectionCard
      title={t("customize_space.access")}
      dataTestId="customize-space-access"
      variant="fullScreen"
    >
      <div className="flex flex-col gap-y-2">
        {shouldShowDraftMessage && <DraftAlert />}
        <AccessForm onChange={onChange} onExit={onExit} />
      </div>
    </SectionCard>
  );
};
